// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"19c43dbc","507":"f7522074","787":"0acdd440"}[chunkId] + ".chunk.js";
};